import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';

import { RouteLink } from 'modules/routing-module';

import { Button, Layout } from 'components/common';
import { InputField } from 'components/forms';
import { AuthWrapper } from 'components/wrapper';

import SendIcon from 'assets/icons/send-email.svg';
import './styles.scss';

export const SendResetPassword: FC = () => {
  const location = useLocation();
  const { domain_web: domainWeb } = React.useMemo(
    () => queryString.parse(location.search),
    [location.search],
  );

  return (
    <AuthWrapper
      title="Email Delivered"
      subtitle="Check your email, you will now receive a recovery email"
    >
      <Layout className="p-4-em" flex>
        <InputField>
          <img src={SendIcon} className="page-image auth__icon" alt="Sent" />
        </InputField>
        <InputField>
          {domainWeb !== undefined ? (
            <Button
              tag="a"
              href={domainWeb as string}
              target="_blank"
              primary
              className="auth__button auth__button--margin"
            >
              <FormattedMessage id="Go to email" defaultMessage="Go to email" />
            </Button>
          ) : (
            <RouteLink
              routeKey="Login"
              className="button button-primary auth__button auth__button--margin"
            >
              <FormattedMessage id="Sign In" defaultMessage="Sign in" />
            </RouteLink>
          )}
        </InputField>
      </Layout>
    </AuthWrapper>
  );
};
